module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "appView"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "appView",
    staticClass: "appView"
  }) : _vm._e()], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "overlay": false,
      "position": "top"
    },
    model: {
      value: (_vm.notifyShow),
      callback: function($$v) {
        _vm.notifyShow = $$v
      },
      expression: "notifyShow"
    }
  }, [_c('div', {
    staticClass: "notify-box",
    style: ({
      paddingTop: _vm.ptHeight + 'rem'
    }),
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'waitSendOrderList'
        })
      }
    }
  }, [_vm._v("\n            您有一笔新的待发货订单\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-614339f0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = ftdI
// module chunks = 51